import type { ProgramEventInviteeRole, ProgramUserRsvp } from 'models';
import { Col, Form, Input, Modal, Row, Segmented, Select } from 'ui';
import { useEventInviteesRoleFilterOptions, useEventInviteesStatusFilterOptions } from './hooks';

export type EventInviteesFiltersFormValues = {
  role?: 'all' | ProgramEventInviteeRole;
  search?: string;
  status?: 'all' | ProgramUserRsvp;
  type: EventInviteesFiltersType;
};

export type EventInviteesFiltersType = 'community' | 'individual';

type P = {
  hasDistributionList: boolean;
  type: EventInviteesFiltersType;
};

const EventInviteesFilters = ({ hasDistributionList, type }: P) => {
  const inviteesStatusOptions = useEventInviteesStatusFilterOptions();
  const inviteesRoleOptions = useEventInviteesRoleFilterOptions();

  return (
    <Modal.ScrollableContent.Header>
      <Row gutter="ms">
        {hasDistributionList ? (
          <Col span={8}>
            <Form.Item<EventInviteesFiltersFormValues> label="Invitations" name="type" noOptional>
              <Segmented<EventInviteesFiltersType>
                options={[
                  { label: 'Individual', value: 'individual' },
                  { label: 'Community', value: 'community' },
                ]}
                size="large"
              />
            </Form.Item>
          </Col>
        ) : null}
        {type === 'community' ? null : (
          <>
            <Col span={hasDistributionList ? 16 : 24}>
              <Form.Item<EventInviteesFiltersFormValues> label="Search" name="search" noOptional>
                <Input hasSearch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item<EventInviteesFiltersFormValues> label="Role" name="role" noOptional>
                <Select options={inviteesRoleOptions} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item<EventInviteesFiltersFormValues> label="Status" name="status" noOptional>
                <Select options={inviteesStatusOptions} />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Modal.ScrollableContent.Header>
  );
};

export default EventInviteesFilters;
